import React from 'react';
import { useDispatch } from 'react-redux';
import { startTakeover } from 'shared/store/dashboard-slice';
import { SessionControlButton } from 'shared/../browser/components/Dashboard/VisitorFocused/SessionControls/SessionControlButton';
import { PlayerHint, PlayerHintProps } from './index';
import PointerIcon from 'shared/assets/images/pointer-icon.svg';

export const TakeoverHint: React.FC<PlayerHintProps> = ({ isShow }) => {
  const dispatch = useDispatch();

  return (
    <PlayerHint isShow={isShow}>
      <div>Would you like to start a screen takeover?</div>
      <SessionControlButton
        key="takeover"
        primary={true}
        disabled={false}
        active={false}
        icon={<PointerIcon />}
        text="Request control"
        onClick={() => dispatch(startTakeover())}
      />
    </PlayerHint>
  );
};
